import React, { useState } from 'react';
import { FaLightbulb, FaBuilding } from 'react-icons/fa';
import LandingPageIdeas from './LandingPageIdeas';
import AgencyRequests from './AgencyRequests';

const tabs = [
  { key: 'ideas', label: 'Founder Ideas', icon: <FaLightbulb className="w-4 h-4" /> },
  { key: 'agency', label: 'Agency Requests', icon: <FaBuilding className="w-4 h-4" /> },
] as const;

const LandingPageSubmissions: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'ideas' | 'agency'>('ideas');

  return (
    <div className="space-y-0">
      {/* Tab Bar */}
      <div className="flex items-center gap-1 bg-gray-100 p-1 rounded-xl w-fit mb-6">
        {tabs.map(({ key, label, icon }) => (
          <button
            key={key}
            onClick={() => setActiveTab(key)}
            className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold transition-all duration-200 ${
              activeTab === key
                ? 'bg-white text-gray-900 shadow-sm'
                : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            <span className={activeTab === key ? 'text-primary' : ''}>{icon}</span>
            {label}
          </button>
        ))}
      </div>

      {/* Content */}
      {activeTab === 'ideas' ? <LandingPageIdeas /> : <AgencyRequests />}
    </div>
  );
};

export default LandingPageSubmissions;
